export default {"src":"/_next/static/media/undraw_active_support_re_b7sj.eae2b877.svg","height":551,"width":652};